import { HttpContext, HttpContextToken } from '@angular/common/http'

/**
 * HTTP status codes for which the {@link ApiInterceptor} should NOT display an
 * error toast. Use it for requests where a given status is an expected, benign
 * outcome (e.g. a 404 when a resource has simply never been created yet).
 */
export const SILENT_ERROR_STATUSES = new HttpContextToken<number[]>(() => [])

/**
 * Convenience helper to build an {@link HttpContext} that suppresses the error
 * toast for the given status codes.
 */
export function silentErrorStatuses(...statuses: number[]): HttpContext {
    return new HttpContext().set(SILENT_ERROR_STATUSES, statuses)
}
